export default __webpack_public_path__ + "static/B0170-657c90addb25d43e7fccbfdd3478eb9c.png";